import React from 'react';
import { ChevronRight } from '../../assets/icons';
import PropTypes from 'prop-types';
import './TransactionItem.scss';
import { getUsCurrencyFormat } from '../../utils/usCurrencyFormatter';

const TransactionItem = ({ transaction, action }) => {
  const { initiatedOn, senderSource, amount, receiverSource, transactionType, status, tradeDetails, scheduleDate, dividendDetails, platformFee } = transaction;
  const getDate = (dateString) => {
    const dateStr = dateString;
    const mm = dateStr.slice(5, 7);
    const dd = dateStr.slice(8, 10);
    const yyyy = dateStr.slice(0, 4);
    return `${mm}/${dd}/${yyyy}`;
  };
  const resourceDataShares = () => {
    if (transactionType === 'Deposit' || transactionType === 'Withdrawal') {
      if (senderSource?.sourceType === 'Wallet') {
        return `${receiverSource?.lastFourDigit ? `***${receiverSource?.lastFourDigit}` : ''}`;
      } else {
        return `${senderSource?.lastFourDigit ? `***${senderSource?.lastFourDigit}` : ''}`;
      }
    }
    if (transactionType === 'Bought' || transactionType === 'Sold') {
      return `${tradeDetails?.noOfShares} Share(s)`;
    }
    if (transactionType === 'Dividend') {
      return `${dividendDetails?.noOfShares} Share(s)`;
    }
  };
  const resourceDataProperty = () => {
    if (transactionType === 'Deposit' || transactionType === 'Withdrawal') {
        return `${senderSource?.brandName ? senderSource?.brandName : "NA"}`;
    }
    if (transactionType === 'Bought' || transactionType === 'Sold') {
      return `${tradeDetails?.propertyName ? tradeDetails?.propertyName : 'NA'}`;
    }
    if (transactionType === 'Dividend') {
      return `${dividendDetails?.propertyName ? dividendDetails?.propertyName : 'NA'}`;
    }
  };
  return (
    <div className={`${status === 'Scheduled' ? 'trans-item trans-item--scheduled' : 'trans-item'}`}>
      <p className='trans-item__date'>{status === 'Scheduled' ? getDate(scheduleDate) : getDate(initiatedOn)}</p>
      <p className='trans-item__type'>
        {transactionType ? (
          status === 'Completed' && transactionType === 'Deposit' ? 'Deposited' :
            transactionType === 'Bought' ?
              tradeDetails && tradeDetails?.marketPlace === 'Primary' ? 'Buy (Primary)' : 'Buy' :
              transactionType === 'Sold' ? 'Sell' :
                transactionType
        ) : 'N/A'}
      </p>
      <p className='trans-item__type'>
        {resourceDataShares()}
      </p>
      <p className='trans-item__details' onClick={() => action(transaction)}>
        {resourceDataProperty()}
      </p>
      <p className='trans-item__amount'>
        {transactionType === 'Bought' || transactionType === 'Withdrawal' ? `-$${getUsCurrencyFormat(amount - platformFee)}` : `$${getUsCurrencyFormat(amount - platformFee)}`}
      </p>
      {status === 'Scheduled' && (
        <ChevronRight className='cursor-pointer trans-item__icon' size={24} verticalAlign='middle' onClick={() => action(transaction)} />
      )}
    </div>
  );
};

TransactionItem.propTypes = {
  date: PropTypes.string,
  transactionType: PropTypes.string,
  details: PropTypes.string,
  amount: PropTypes.string,
  isScheduled: PropTypes.bool,
  action: PropTypes.func,
};

export default TransactionItem;
